import { UntypedFormGroup } from "@angular/forms";

export function createPatchBody(formGroup: UntypedFormGroup): any {
  const bodyArray = [];

  for (const controlName in formGroup.value) {
    if (formGroup.controls[controlName].dirty) {
      bodyArray.push({
        op: 'replace',
        path: `/${controlName}`,
        value: formGroup.value[controlName],
      });
    }
  }

  return bodyArray;
}

export function createPutFormData(formGroup: UntypedFormGroup): FormData {
  const formData: FormData = new FormData();

  for (const controlName in formGroup.value) {
    if (formGroup.value[controlName]) {
      if (!(formGroup.controls[controlName] as UntypedFormGroup).controls) {
        formData.append(controlName, formGroup.value[controlName]);
      } else {
        for (const subControlName in formGroup.controls[controlName].value) {
          if (formGroup.controls[controlName].value[subControlName]) {
            formData.append(
              `${controlName}[${subControlName}]`,
              formGroup.controls[controlName].value[subControlName]
            );
          }
        }
      }
    }
  }
  return formData;
}
